<template>
  <div class="photos-page">
    <Toolbar class="photos-page__toolbar" title-tag="h1">
      <template #title>Фото</template>
    </Toolbar>

    <div class="photos-page__row row">
      <div
        v-for="(album, index) in albums"
        :key="index"
        class="col-12 col-lg-4 col-sm-6"
      >
        <AlbumCard :album="album" />
      </div>
    </div>
  </div>
</template>

<script>
import { Toolbar } from "@/components/ui/toolbar";
import service from "@/services/photos";
import AlbumCard from "@/components/photos/AlbumCard";

export default {
  name: "PhotosPage",
  components: {
    AlbumCard,
    Toolbar
  },
  data: () => ({
    albums: new Array(6)
  }),
  created() {
    this.getAlbums();
  },
  methods: {
    async getAlbums() {
      this.loading = true;
      const { success, data } = await service.getAlbums();
      if (success) {
        this.albums = data;
      }
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
.photos-page {
  &__toolbar {
    margin-bottom: 20px;
  }
  &__row {
    @include customGutter(7px);
  }
}
</style>
